(function () {
  const locale = (document.documentElement.lang || '').toLowerCase();
  const isGerman = locale.startsWith('de');

  const copy = {
    title: isGerman ? 'Widerruf erkl\u00e4ren' : 'Declare Withdrawal',
    description: isGerman
      ? 'Geben Sie Name, E-Mail-Adresse und Bestellnummer an. Die Bestellnummer dient der Zuordnung Ihres Widerrufs. Wenn Sie nur einzelne Artikel widerrufen m\u00f6chten, beschreiben Sie diese im Feld Artikel.'
      : 'Enter your name, email address and order number. The order number is used to match your withdrawal to your order. If you only want to withdraw from individual items, describe them in the item field.',
    notice: isGerman
      ? 'Hinweis: Die automatische Bestellpr\u00fcfung dient nur der Zuordnung. Falls Ihre Bestellung nicht automatisch gefunden wird, k\u00f6nnen Sie den Widerruf trotzdem absenden. Bitte pr\u00fcfen Sie Bestellnummer und E-Mail-Adresse und beschreiben Sie die betroffenen Artikel im Formular, wenn keine Artikelauswahl angezeigt wird.'
      : 'Note: The automatic order lookup is only used to match your request to an order. If your order is not found automatically, you can still submit your withdrawal. Please check the order number and email address and describe the affected items in the form if no item selection is shown.',
  };

  function getWithdrawalUrl(src) {
    try {
      if (!src || src.indexOf('euwiderrufsbutton.de/withdrawal') === -1) return false;

      return new URL(src);
    } catch (error) {
      return false;
    }
  }

  function rewriteIframeUrl(iframe) {
    if (iframe.dataset.piurWithdrawalPatched === 'true') return;

    const url = getWithdrawalUrl(iframe.src);
    if (!url) return;

    url.searchParams.set('showOrderLookup', 'true');
    url.searchParams.set('requireOrderNumber', 'true');
    url.searchParams.set('confirmStep', 'true');

    const nextSrc = url.toString();
    iframe.dataset.piurWithdrawalPatched = 'true';

    if (nextSrc !== iframe.src) {
      iframe.src = nextSrc;
    }
  }

  function addNotice(iframe) {
    const container = iframe.parentElement;
    if (!container || container.querySelector('.piur-withdrawal-form-notice')) return;

    const notice = document.createElement('div');
    notice.className = 'piur-withdrawal-form-notice';
    notice.setAttribute('role', 'note');
    notice.textContent = copy.notice;

    container.insertBefore(notice, iframe);
  }

  function updateModalCopy() {
    const title = document.querySelector('.wb-modal-title');
    const description = document.querySelector('.wb-modal-description');

    if (title && title.textContent !== copy.title) title.textContent = copy.title;
    if (description && description.textContent !== copy.description) {
      description.textContent = copy.description;
    }
  }

  function scan() {
    updateModalCopy();

    document.querySelectorAll('iframe').forEach(function (iframe) {
      if (getWithdrawalUrl(iframe.src)) {
        rewriteIframeUrl(iframe);
        addNotice(iframe);
      }
    });
  }

  function runScanSequence() {
    scan();
    window.setTimeout(scan, 500);
    window.setTimeout(scan, 1500);
  }

  const mobileStickySelector = '[class*="piur-product-mobile-sticky-"]';
  let observedMobileSticky = null;
  let mobileStickyResizeObserver = null;

  function syncMobileStickyCartOffset() {
    const mobileSticky = Array.from(document.querySelectorAll(mobileStickySelector)).find(
      function (element) {
        const styles = window.getComputedStyle(element);
        return styles.display !== 'none' && styles.position === 'fixed';
      }
    );

    document.body.classList.toggle('piur-has-mobile-sticky-cart', Boolean(mobileSticky));

    if (!mobileSticky) {
      document.documentElement.style.removeProperty('--piur-mobile-sticky-cart-height');
      if (mobileStickyResizeObserver) mobileStickyResizeObserver.disconnect();
      observedMobileSticky = null;
      return;
    }

    const stickyHeight = Math.ceil(mobileSticky.getBoundingClientRect().height);
    if (stickyHeight > 0) {
      document.documentElement.style.setProperty(
        '--piur-mobile-sticky-cart-height',
        stickyHeight + 'px'
      );
    }

    if ('ResizeObserver' in window && observedMobileSticky !== mobileSticky) {
      if (!mobileStickyResizeObserver) {
        mobileStickyResizeObserver = new ResizeObserver(syncMobileStickyCartOffset);
      } else {
        mobileStickyResizeObserver.disconnect();
      }

      mobileStickyResizeObserver.observe(mobileSticky);
      observedMobileSticky = mobileSticky;
    }
  }

  function initialize() {
    runScanSequence();
    syncMobileStickyCartOffset();
    window.addEventListener('resize', syncMobileStickyCartOffset, { passive: true });
    window.addEventListener('orientationchange', syncMobileStickyCartOffset, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

})();
